import { resolveLocaleFromPathname } from '@/src/shared/lib/i18n/resolveLocaleFromPathname';
import { redirectTo } from '@/src/shared/lib/navigation/redirectTo';
import { clearClientSessionCache } from './clientSession';

/**
 * Single client-side logout path shared by the UserMenu action and the 401
 * handler so the two cannot drift: drop the in-memory token cache, clear the
 * HttpOnly session cookie via the server route, then hard-redirect to the
 * locale-scoped login, or to `redirectPath` when the caller needs the login to
 * lead somewhere. The logout request is best-effort; we redirect even if it
 * fails so the user is never stranded on an authenticated screen.
 */
export async function performClientLogout(redirectPath?: string): Promise<void> {
  if (typeof window === 'undefined') return;

  const locale = resolveLocaleFromPathname(window.location.pathname);

  clearClientSessionCache();

  try {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
  } catch {
    // Best-effort: still redirect to login even if clearing the cookie fails.
  }

  redirectTo(redirectPath ?? `/${locale}/login`);
}
